var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountrySelector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4259_1300",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H34V40H20C8.9543 40 0 31.0457 0 20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H34V40H20C8.9543 40 0 31.0457 0 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 20C-1 8.40202 8.40202 -1 20 -1H34V1H20C9.50659 1 1 9.50659 1 20H-1ZM34 41H20C8.40202 41 -1 31.598 -1 20H1C1 30.4934 9.50659 39 20 39H34V41ZM20 41C8.40202 41 -1 31.598 -1 20C-1 8.40202 8.40202 -1 20 -1V1C9.50659 1 1 9.50659 1 20C1 30.4934 9.50659 39 20 39V41ZM34 0V40V0Z",
    fill: "#262626",
    fillOpacity: 0.07,
    mask: "url(#path-1-inside-1_4259_1300)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.659 15.4697C20.3661 15.1768 19.8913 15.1768 19.5984 15.4697L16.659 18.409C15.7803 19.2877 15.7803 20.7123 16.659 21.591L19.5984 24.5303C19.8913 24.8232 20.3661 24.8232 20.659 24.5303C20.9519 24.2374 20.9519 23.7626 20.659 23.4697L17.7197 20.5303C17.4268 20.2374 17.4268 19.7626 17.7197 19.4697L20.659 16.5303C20.9519 16.2374 20.9519 15.7626 20.659 15.4697Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountrySelector);
export default __webpack_public_path__ + "static/media/country-selector.822888b7a4e620000e27bd56658c9b76.svg";
export { ForwardRef as ReactComponent };